import styled, { keyframes } from 'styled-components';
import { GRUNDFOS_BLUE, BLUE3 } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const AgentWelcome = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${MEDIA.MOBILE} {
    justify-content: flex-start;
    overflow-y: auto;
  }
`;

export const AgentWelcome__Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px;
  max-width: 800px;
  width: 100%;
  box-sizing: border-box;
  animation: ${fadeInUp} 0.4s ease both;

  ${MEDIA.MOBILE} {
    padding: 32px 20px;
  }
`;

export const AgentWelcome__Logo = styled.img`
  width: clamp(72px, 10vw, 96px);
  height: clamp(72px, 10vw, 96px);
  margin-bottom: clamp(20px, 2.5vw, 28px);
  opacity: 0.9;
`;

export const AgentWelcome__Title = styled.h1`
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: clamp(24px, 4.2vw, 34px);
  margin: 0 0 12px 0;
  line-height: 1.2;

  ${MEDIA.MOBILE} {
    margin: 0 0 10px 0;
  }
`;

export const AgentWelcome__Subtitle = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: clamp(15px, 2vw, 18px);
  margin: 0 0 40px 0;
  line-height: 1.6;
  max-width: 540px;

  ${MEDIA.MOBILE} {
    margin: 0 0 28px 0;
    max-width: 100%;
  }
`;

export const AgentWelcome__Suggestions = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 700px;
  margin-bottom: 32px;

  ${MEDIA.MOBILE} {
    display: none;
  }
`;

export const AgentWelcome__SuggestionCard = styled.button`
  background: white;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    border-color: ${GRUNDFOS_BLUE};
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const AgentWelcome__SuggestionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: ${GRUNDFOS_BLUE};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 18px;
`;

export const AgentWelcome__SuggestionContent = styled.div`
  flex: 1;
`;

export const AgentWelcome__SuggestionTitle = styled.h3`
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  margin: 0;
`;

export const AgentWelcome__GetStartedText = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  margin: 0;
  opacity: 0.8;

  ${MEDIA.MOBILE} {
    display: none;
  }
`;

export const AgentWelcome__TestingRibbon = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  max-width: 600px;
  background: #fff8e6;
  border: 1.5px solid #ffc107;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 24px;
  text-align: left;
  box-sizing: border-box;
`;

export const AgentWelcome__TestingRibbonIcon = styled.span`
  font-size: 18px;
  line-height: 1.4;
  flex-shrink: 0;
`;

export const AgentWelcome__TestingRibbonText = styled.p`
  color: #7d4e00;
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  margin: 0;
  line-height: 1.5;

  strong {
    font-family: ${FONT_FAMILY.SEMI_BOLD};
  }
`;
